import Bowser from "bowser";

function GetBrowser() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    return browser.getBrowser();
}

function Browser() {
    const browserDetails = GetBrowser();

    return (
        <div className="information_card">
            <h3>Browser</h3>
            <p className="information" data-browser-name={browserDetails.name} data-browser-version={browserDetails.version}>{browserDetails.name} - {browserDetails.version}</p>
        </div>
    );
}
export default Browser;